import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from './components/auth/PrivateRoute';
import PublicRoute from './components/auth/PublicRoute';
import Login from './components/auth/Login';
import StyleGuide from './components/StyleGuide';
import Logout from './components/auth/Logout';
import NotFound from './components/NotFound';
import Home from './components/Home';
import ChefOnboardingLogin from './components/onboarding/ChefOnboardingLogin';
import ClientOnboarding from './components/onboarding/ClientOnboarding';
import ClientOnboardingNew from './components/new/onboarding/ClientOnboardingNew';
import ClientThankYou from './components/onboarding/client/ClientThankYou';
import ChefOnboarding from './components/onboarding/ChefOnboarding';
import ChefThankYou from './components/onboarding/chef/ChefThankYou';
import ChefProfile from './components/chef/ChefProfile';
import ChefInviteConfirm from './components/chef/ChefInviteConfirm';
import AdminRouter from './components/admin/AdminRouter';
import withUser from './components/auth/withUser';
import MenuSelection from './components/menuSelection/MenuSelection';
import MenuSelectionThanks from './components/menuSelection/MenuSelectionThanks';
import PasswordForgot from './components/auth/PasswordForgot';
import PasswordReset from './components/auth/PasswordReset';
import ServiceViewSwitch from './components/service/ServiceViewSwitch';
import ChefServiceOpportunity from './components/chef/ChefServiceOpportunity';
import withTracker from './components/withTracker';
import ClientServiceSkip from './components/chef/ClientServiceSkip';

class MainRouter extends React.Component {
  render() {
    const { isLoggedIn, isAuthorized, windowWidth, isMobile } = this.props;
    return (
      <Switch>
        <Route exact path="/" component={withTracker(Home)} />

        <PrivateRoute
          exact
          path="/menu-selection/:id/thanks"
          authed={isAuthorized('client')}
          component={MenuSelectionThanks}
        />

        <PrivateRoute
          path="/menu-selection/:id"
          authed={isAuthorized('client')}
          component={MenuSelection}
          componentProps={{ windowWidth }}
        />

        <PublicRoute
          exact
          path="/new-client/thank-you"
          authed={isLoggedIn()}
          component={ClientThankYou}
        />

        {/* New Onboarding */}
        <PublicRoute
          exact
          path="/new-client"
          authed={isLoggedIn()}
          component={ClientOnboardingNew}
          componentProps={{ windowWidth }}
        />

        {/* Old Onboarding */}
        <PublicRoute
          exact
          path="/new-client/old"
          authed={isLoggedIn()}
          component={ClientOnboarding}
          componentProps={{ windowWidth }}
        />

        <Route exact path="/new-chef/start" component={ChefOnboardingLogin} />
        <PrivateRoute
          exact
          path="/new-chef/thank-you"
          authed={isAuthorized('chef')}
          component={ChefThankYou}
        />
        <PrivateRoute
          path="/new-chef"
          authed={isAuthorized('chef')}
          component={ChefOnboarding}
          componentProps={{ windowWidth }}
        />

        <PrivateRoute
          path="/chef-profile/:id?"
          authed={isAuthorized('chef')}
          component={ChefProfile}
          componentProps={{ isMobile }}
        />

        {/* New Client Dashboard */}
        {/*
        <PrivateRoute
          path="/client-profile/:id?"
          authed={isAuthorized('client')}
          component={ClientProfileNew}
          componentProps={{ windowWidth }}
        />
      */}

        <Route
            path='/client-profile/:id?' component={() => {
            window.location.href = "https://www.theculinistas.com/sign-in";
            return null;
        }}/>

        {/* Old Client Dashboard */}
        {/* <PrivateRoute
          path="/client-profile/old"
          authed={isAuthorized('client')}
          component={ClientProfile}
          componentProps={{ windowWidth }}
        /> */}

        <PrivateRoute
          path="/service/:id"
          authed={isLoggedIn()}
          component={ServiceViewSwitch}
        />

        <PrivateRoute
          path="/service-opportunity"
          authed={isAuthorized('chef')}
          component={ChefServiceOpportunity}
        />

        <Route path="/style-guide" component={StyleGuide} />

        {/* <PublicRoute
          path="/login"
          exact
          authed={isLoggedIn()}
          component={ClientLogin}
          componentProps={{ windowWidth }}
        /> */}

        {/* Two ways to pass props through a Route: */}
        {/* 1) Use render and inline component */}
        {/*<Route exact path="/login" render={() => <Login login={this.login} />} />*/}
        {/* 2) Use render and function that returns component */}
        {/*<Route exact path="/login" render={this.loginPage} />*/}
        {/*<Route exact path="/login" render={props => renderComponent(Login, props, {login})} />*/}
        <PublicRoute
          path="/login/:role"
          authed={isLoggedIn()}
          component={Login}
        />

        <Route path='/login' component={() => {
            window.location.href = "https://www.theculinistas.com/sign-in";
            return null;
        }}/>

        <PrivateRoute
          exact
          path="/logout"
          authed={isLoggedIn()}
          component={Logout}
        />

        <PublicRoute
          exact
          path="/forgot-password/:role?"
          authed={isLoggedIn()}
          component={PasswordForgot}
        />
        <PublicRoute
          exact
          path="/reset-password/:role?"
          authed={isLoggedIn()}
          component={PasswordReset}
        />

        {/* WITH TRACKER IS BREAKING ALL MODALS */}
        <PrivateRoute
          path="/admin"
          redirectTo="/login/admin"
          authed={isAuthorized('admin')}
          component={AdminRouter}
          componentProps={{ isMobile }}
        />

        <Route
          exact
          path="/chef-confirm-invite/accept/:token"
          render={(props) => <ChefInviteConfirm {...props} accept={true} />}
        />
        <Route
          exact
          path="/chef-confirm-invite/reject/:token"
          render={(props) => <ChefInviteConfirm {...props} accept={false} />}
        />
        <Route
          exact
          path="/client-service-skip/:token"
          render={(props) => <ClientServiceSkip {...props} accept={false} />}
        />
        <Route component={withTracker(NotFound)} />
      </Switch>
    );
  }
}

export default withUser(MainRouter);



// WEBPACK FOOTER //
// ./src/MainRouter.js